import $ from 'jquery';

import Section from '../Section';

export default class Password extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$head = $('.site-header');
    this.$focusableEls = this.$head.find('a[href], input:not([disabled]):not([type="hidden"]), button:not([disabled]), [tabindex="0"]');
    this.$password = this.$head.find('input#password');
    this.firstFocusableEl = /** @type {HTMLElement} */ (this.$focusableEls[0]);
    this.lastFocusableEl = /** @type {HTMLElement} */ (this.$focusableEls[this.$focusableEls.length - 1]);

    this.load();
  }

  load = () => {
    var self = this;

    $('.password-show').click(function() {
      self.$head.slideToggle('slow').addClass('open');
      $('.password--container').addClass('password-modal--open');
      self.$password.focus();
    });

    $('.password--close').click(function() {
      self.$head.slideToggle('slow').removeClass('open');
      $('.password--container').removeClass('password-modal--open');
      self.$password.blur();
    });

    $(function() {
      if($('.storefront-password-form .errors').length) {
        self.$head.slideDown('slow').addClass('open');
        self.$password.focus();
      }
    });

    // Detect click outside of popup to close it.
    $('.password--wrapper').click(e => {
      if(self.$head.hasClass('open')) {
        if(!self.$head.is(e.target) &&
          self.$head.has(e.target).length === 0 &&
          !$('.password-show').is(e.target)) {
          self.$head.slideUp('slow');
        }
      }
    });

    // Keep tabbing within the modal while it is open.
    $(document).on('keydown', function(e) {

      // @ts-ignore
      e = e || window.event;

      if(e.keyCode == 9) {

        // Keep tab within the open modal.
        if(e.shiftKey) {
          if(document.activeElement === self.firstFocusableEl) {
            e.preventDefault();
            self.lastFocusableEl.focus();
          }
        }
        else {
          if(document.activeElement === self.lastFocusableEl) {
            e.preventDefault();
            self.firstFocusableEl.focus();
          }
        }
      }
      else if (e.keyCode == 27) {
        // Escape to close popup.
        if(self.$head.hasClass('open')) {
          self.$head.slideToggle('slow').removeClass('open');
          self.$password.blur();
        }
      }
    });
  }

}
